import { Injectable } from '@angular/core'

@Injectable({
    providedIn: 'root',
})
export class LazyLoaderService {
    static ELF_SIGHT_SCRIPT_ID = 'elf-sight-script'
    elfSightScriptLoaded = false

    constructor() {}

    loadElfsightJsScript() {
        if (!this.elfSightScriptLoaded) {
            this.addScript('https://apps.elfsight.com/p/platform.js', LazyLoaderService.ELF_SIGHT_SCRIPT_ID)
            this.elfSightScriptLoaded = true
        }
    }

    addScript(source: string, id: string) {
        const newElement = document.createElement('script'),
            existingElement = document.getElementsByTagName('script')[0]
        newElement.async = true
        newElement.src = source
        newElement.id = id
        existingElement.parentNode?.insertBefore(newElement, existingElement)
    }
}
